import { OrderingCategory, OrderingItem, OrderItem } from 'kiolyn-api';
import newId from './NewId';

export default function newOrderItem(
  category: OrderingCategory,
  item: OrderingItem
): OrderItem {
  return {
    id: newId(),
    type: 'order-item',
    categoryid: category.id,
    itemid: item.id,
    name: item.name || '',
    name2: item.name2,
    price: item.price,
    count: 1,
    image_url: item.imageURL,
    note: '',
    modifiers: [],
    subtotal: 0,
    non_taxable: item.non_taxable,
    gift_card: category.gift_card,
    gift_certificate: category.gift_certificate,
    item_note: item.note
  };
}
